// src/components/common/audio-player/ui/AudioSpeed.tsx

"use client";
import React from "react";
import { Rabbit, Snail } from "lucide-react";

import "./AudioSpeed.css";

type Props = {
  rate: number;
  onSlower: () => void;
  onFaster: () => void;
};

const AudioSpeed: React.FC<Props> = ({ rate, onSlower, onFaster }) => {
  return (
    <div className="tl-speed">
      <button type="button" className="tl-icon-btn" onClick={onSlower} aria-label="Decrease speed">
        <Snail size={20} strokeWidth={1} />
      </button>

      <span className="tl-chip" aria-label={`Playback speed ${rate}x`} title={`Speed ${rate}×`}>
        {rate}×
      </span>

      <button type="button" className="tl-icon-btn" onClick={onFaster} aria-label="Increase speed">
        <Rabbit size={20} strokeWidth={1} />
      </button>
    </div>
  );
};

export default AudioSpeed;
